import { TranslatePipe } from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';

import { CompanyGroupService } from '../../../../_services';

@Component({
    selector: 'companyGroup-create',
    templateUrl: './create.component.html',
    styleUrls: ['../companyGroup.component.scss', './create.component.scss'],
    providers: [TranslatePipe],
})
export class CompanyGroupCreateComponent implements OnInit {
    error: string;
    success: string;
    account: any;
    currentcompanyGroup: any;

    constructor(private companyGroupService: CompanyGroupService) {}

    ngOnInit() {
        this.currentcompanyGroup = {
            name: '',
            siret: '',
            address1: '',
            address2: '',
            zipCode: '',
            city: '',
            deleted: false,
            initialized: true,
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/directory/group/create/create.component.ts